<div class="modal-header p-0">
  <img src="{{ perk.modal.images.header }}" />
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
  </button>
</div>

<div class="modal-body" [ngClass]="{ 'show-voucher': showVoucherCode }">
  <form #partnerModal="ngForm" novalidate>
    <div *ngIf="showVoucherCode" class="row">
      <div class="col-12 col-lg-8 offset-lg-2 my-3">
        <div class="row">
          <div class="col-12">
            <h4 class="text-center mb-3">
              {{ perk.voucher.heading ? perk.voucher.heading : "Voucher code" }}
            </h4>
          </div>

          <div
            *ngIf="!alert && perk.voucher.code"
            class="col-12 p-0 mb-4 partner-main_voucher position-relative"
          >
            <input
              class="p-5 text-center"
              (click)="copyVoucherCode(voucherCode)"
              id="voucherCode"
              #voucherCode
              type="text"
              readonly
              value="{{ perk.voucher.code }}"
            />
            <fa-icon [icon]="['fas', 'copy']"> </fa-icon>
          </div>

          <div *ngIf="alert" class="col-12 my-3">
            <ngb-alert
              [type]="alert.type"
              (closed)="closeAlert()"
              class="text-center"
            >
              {{ alert.message }}
            </ngb-alert>
          </div>

          <div
            *ngIf="perk.voucher.helpText && perk.voucher.code"
            class="col-12"
          >
            <p class="text-center">
              {{ perk.voucher.helpText }}
            </p>
          </div>

          <div class="col-12 text-center my-3">
            <div class="btn-group text-center" data-toggle="buttons">
              <button
                [id]="perkID"
                class="btn btn-lg text-white go-to-3rd-party-site"
                trackClickEvent
                [eventNumber]="ClickEventNumbersEnum.TileOpensLink"
                [eventDetails]="perk.tag"
                (click)="submitModal()"
                [ngStyle]="perk.color && { 'background-color': perk.color }"
                type="button"
              >
                {{ perk.voucher.buttonCopy || "Claim perk" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!showVoucherCode" class="row">
      <div class="col-12 col-lg-4">
        <img class="mb-3 perk-image" src="{{ perk.modal.images.main }}" />
        <img
          class="d-none d-lg-block perk-image"
          src="{{ perk.modal.images.secondary }}"
        />
      </div>

      <div
        class="col-12 col-lg-8 d-flex flex-column justify-content-center align-items-stretch"
      >
        <div *ngIf="perk.modal.copy" class="partner-main_content_top">
          <div class="row">
            <div class="col-12">
              <h4 class="modal-title my-3" [innerHTML]="perk.modal.copy.heading">
              </h4>
              <p
                class="mb-3"
                [ngClass]="{'repOfCatsFontSize': perk.name === 'republicOfCats2'}"
                [innerHTML]="perk.modal.copy.main"
              >
              </p>
              <h4 *ngIf="perk.modal.copy.headingBottom" class="modal-title my-3" [ngStyle]="{'color': perk.color}" [innerHTML]="vaucherText"></h4>
              <p
                *ngIf="perk.modal.copy.keyPoints"
                class="bg-light text-start p-3 my-4 key-points"
                [ngStyle]="perk.color && { 'border-color': perk.color }"
                [innerHTML]="perk.modal.copy.keyPoints"
              >
              </p>
              <p *ngIf="perk.modal.copy.tagline" class="mb-3" [innerHTML]="perk.modal.copy.tagline">
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div *ngIf="perk.modal.checkbox" class="col-12 text-center checkbox">
            <div class="btn-group d-inline-block" data-toggle="buttons">
              <label class="btn btn-light p-3 ps-5 mb-3 checkbox-wrapper">
                <div class="checkbox-inner">
                  <input
                    autocomplete="off"
                    name="checkbox"
                    [(ngModel)]="perk.modal.checkbox.checked"
                    [required]="perk.modal.checkbox.required"
                    [checked]="perk.modal.checkbox.checked"
                    (click)="trackEvent('perksmodal::permission1::clicked')"
                    type="checkbox"
                  />
                  <span
                    class="me-3 text-white checkmark"
                    [ngStyle]="perk.color && { 'background-color': perk.color }"
                  >
                  </span>
                </div>
                <p class="m-0">
                  {{ perk.modal.checkbox.copy }}
                </p>
              </label>
            </div>
          </div>

          <div class="col-12 text-center">
            <div
              class="d-inline-block my-3"
              [ngClass]="{
                'd-block button-checkbox': perk.modal.button.checkboxStyle
              }"
            >
              <div class="btn-group text-center" data-toggle="buttons">
                <button
                  class="btn btn-lg"
                  [id]="perkID"
                  [ngClass]="{
                    'w-100 btn-light p-3': perk.modal.button.checkboxStyle,
                    'text-white': !perk.modal.button.checkboxStyle,
                    'claim-offer': !perk.modal.button.url,
                    'go-to-3rd-party-site': perk.modal.button.url
                  }"
                  trackClickEvent
                  [eventNumber]="perk.modal.button.url ? ClickEventNumbersEnum.TileOpensLink : ClickEventNumbersEnum.TileOpensLinkInModal"
                  [eventDetails]="perk.tag"
                  (click)="submitModal()"
                  [disabled]="!partnerModal.valid || loading"
                  [ngStyle]="
                    perk.color &&
                    !perk.modal.button.checkboxStyle && {
                      'background-color': perk.color
                    }
                  "
                  type="button"
                >
                  <span
                    *ngIf="perk.modal.button.checkboxStyle"
                    class="pseudo-checkbox"
                    [ngStyle]="perk.color && { 'background-color': perk.color }"
                  >
                  </span>
                  {{ loading ? "Loading..." : perk.modal.button.copy }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div
              *ngIf="perk.modal.copy.smallprint"
              class="col-12 text-start mt-3"
            >
              <p>
                <small>{{ perk.modal.copy.smallprint }}</small>
              </p>
            </div>
            <div
              *ngIf="!perk.modal.options || !perk.modal.options.noTerms"
              class="col-12 text-center"
            >
              <a
                href="{{
                  perk.modal.options && perk.modal.options.termsLink
                    ? perk.modal.options.termsLink
                    : '/perk-terms#' + perk.name
                }}"
                target="_blank"
              >
                Terms and conditions
                <fa-icon class="ms-2" [icon]="['fas', 'external-link-alt']">
                </fa-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
